import script from "./LandingAccessModal.vue?vue&type=script&setup=true&lang=js"
export * from "./LandingAccessModal.vue?vue&type=script&setup=true&lang=js"

import "./LandingAccessModal.vue?vue&type=style&index=0&id=05b57c94&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-05b57c94"]])

export default __exports__